import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-pending-verification',
  templateUrl: './pending-verification.component.html',
  styleUrls: ['./pending-verification.component.css']
})
export class PendingVerificationComponent implements OnInit {
  contactDetails = {};
  constructor(private router: Router, private _api: ApiService) { }

  ngOnInit() {
    setTimeout(() => {
      this.getContactUS();
    });
  }
  backToLogin(){
    this._api.logOut();
  }
  getContactUS() {
    this._api.functionGET('global_settings/contact', {}).subscribe((res) => {
      this.contactDetails = res['data'];
    });
  }
}
